jQuery(function ($) {
  // Template contact
  // if ($(".page-template-tpl-contact").length) {
  //   new Choices(".wpcf7-select", {
  //     searchEnabled: false,
  //     itemSelectText: "",
  //     loadingText: "Chargement...",
  //   });
  // }

  selectedStyle();

  function selectedStyle() {
    // Template Accueil
    if ($(".accueil").length) {
      $(".sf-input-select").each(function (index) {
        new Choices(this, {
          searchEnabled: false,
          itemSelectText: "",
          loadingText: "Chargement...",
          choices: [],
          removeItems: true,
          removeItemButton: true,
          allowHTML: true,
        });
      });
    }
    // Template Archive
    if ($(".col-filtre").length) {
      $(".sf-input-select").each(function () {
        new Choices(this, {
          searchEnabled: false,
          itemSelectText: "",
          loadingText: "Chargement...",
          choices: [],
          silent: true,
          allowHTML: true,
        });
      });
    }
  }
  // data-sf-depth >> = 0 (search-filter-build.js)

  $(document).on("sf:ajaxfinish", ".searchandfilter", function () {
    selectedStyle();
    if ($(".formation").length) {
      $('.no-result').hide()
    }
  });
});
